import request from '@/utils/request'

// 上传文件到指定桶
export function uploadToBucket(file, bucket) {
  const formData = new FormData()
  formData.append('file', file)
  return request({
    url: `/file/uploadTo/${encodeURIComponent(bucket)}`,
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 删除 MinIO 指定桶中的对象
export function deleteFrom(bucket, object) {
  return request({
    url: `/file/deleteFrom/${encodeURIComponent(bucket)}`,
    method: 'delete',
    params: { object }
  })
}
